import { type SxProps, type Theme } from '@mui/material'

export const createSegmentedControlSx = (
  minWidth: number,
  darkSelection = false
): SxProps<Theme> => ({
  height: 32,
  '& .MuiToggleButton-root': {
    minWidth,
    px: 1.5,
    py: 0,
    border: '1px solid #EFEFEF',
    color: '#656565',
    fontSize: 10,
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#F7F7F7'
    },
    '&.Mui-selected': {
      backgroundColor: darkSelection ? '#3D3D3D' : '#E8E8E8',
      color: darkSelection ? '#FFFFFF' : '#464646',
      fontWeight: 600,
      '&:hover': {
        backgroundColor: darkSelection ? '#292929' : '#DEDEDE'
      }
    }
  }
})
